import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'app-resumeLoadButton',
    template: `
    <button (click)="reInitiate($event);"
            class="btn btn-outline btn-success btn-rounded btn-sm waves-effect waves-light" 
            style="padding: .3rem .8rem;margin-top:0rem">
      <i class="fas fa-refresh"></i>
    </button>`,
    standalone: false
})
export class ReInitiate implements ICellRendererAngularComp {

  params;
  label: string;

  agInit(params): void {
    this.params = params;
    this.label = this.params.label || null;
  }

  refresh(params?: any): boolean {
    return true;
  }

  reInitiate($event) {
    console.log("hello")
    if (this.params.reInitiate instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data,
        param:this.params
        // ...something
      }
      console.log(params)
      this.params.reInitiate(params);

    }
  }
}
